import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "src/context";
import { Notification } from "src/common/types";
import BackgroundNotification from "src/common/utils/notification";

import {
  Typography,
  Breadcrumb,
  List,
  Avatar,
  Space,
  Badge,
  ConfigProvider,
  DatePicker,
  Dropdown,
  Select,
  Row,
  Col,
} from "antd";
import { ClockCircleOutlined, EllipsisOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const NotificationPage: React.FC = () => {
  const [checking, setChecking] = useState(false);
  const { state } = useContext(AppContext);
  const [items, setItems] = useState<Notification[]>([]);

  const getNotifications = async () => {
    if (localStorage.getItem("token")) {
      setChecking(true);

      const NOTIFICATION = new BackgroundNotification();

      setTimeout(async () => {
        const realData = await NOTIFICATION.getNotifications();
        setItems(realData as Notification[]);
      }, 1000);

      setTimeout(() => {
        setChecking(false);
      }, 1000);
    }
  };

  useEffect(() => {
    getNotifications();
  }, [state.check_notification]);

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>Pages</Breadcrumb.Item>
        <Breadcrumb.Item>Notifications</Breadcrumb.Item>
      </Breadcrumb>

      {/* Page Title */}
      <Title level={2}>Notifications</Title>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} sm={12}>
          <Space size={"middle"} wrap>
            <DatePicker.RangePicker />

            <Select
              placeholder="Select Module"
              style={{ width: 150 }}
              options={[
                { label: "All", value: "all" },
                { label: "Project", value: "project" },
                { label: "Customer", value: "customer" },
              ]}
            />
          </Space>
        </Col>
      </Row>

      <List
        itemLayout="horizontal"
        dataSource={items}
        renderItem={(item) => {
          const isRead = item.status === 1;

          return (
            <List.Item
              style={{
                backgroundColor: isRead ? "transparent" : "#EFF2F6",
                transition: "background 0.2s",
                padding: 16,
                borderRadius: 4,
                cursor: "pointer",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#E3E6ED")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = isRead
                  ? "transparent"
                  : "#EFF2F6")
              }
              actions={[
                <Dropdown
                  trigger={["click"]}
                  menu={{
                    items: [
                      {
                        key: "mark-unread",
                        label: "Mark as unread",
                        onClick: () => console.log("Marked as unread"),
                      },
                    ],
                  }}
                >
                  <EllipsisOutlined
                    key="ellipsis"
                    style={{ fontSize: 16, cursor: "pointer" }}
                  />
                </Dropdown>,
              ]}
            >
              <List.Item.Meta
                avatar={
                  <ConfigProvider
                    theme={{ components: { Badge: { dotSize: 8 } } }}
                  >
                    <Badge
                      dot
                      status={item.status === 0 ? "success" : "default"}
                      offset={[-5, 25]}
                    >
                      <Avatar style={{ backgroundColor: "#1890ff" }}>
                        {item.title[0]}
                      </Avatar>
                    </Badge>
                  </ConfigProvider>
                }
                title={
                  <Space direction="vertical" size={0}>
                    <Text strong={!isRead}>{item.title}</Text>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {item.message}
                    </Text>
                  </Space>
                }
                description={
                  <Space size="small" align="center">
                    <ClockCircleOutlined style={{ fontSize: 12 }} />
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {new Date(item.date).toLocaleString()}
                    </Text>
                  </Space>
                }
              />
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default NotificationPage;
